import React from 'react';
import { useNavigate } from 'react-router-dom';

import CommonImage from '@components/CommonImage';

import { isMyFavourite } from '@features/favourites/utils/favouriteUtil';

import { convertDateToLocal, convertTimeToLocal } from '@utils/Util';

const FavouriteCollectionCard = ({
	folder,
	onDelete,
	parentComponent,
	isCollectionTab = false,
	isLinked,
	onLink,
	onUnLink,
	onPinFolder,
	pinnedFolderIds,
	onUnPinFolder,
	createdBy,
	numberOfProducts
}) => {
	const navigate = useNavigate();

	const handleNavigation = (id) => {
		if (parentComponent === 'FAVOURITE_FOLDER_LIST') {
			navigate(`/favourite/${id}`);
		}
	};

	const handleAction = () => {
		if (isLinked(folder.id) && onUnLink) onUnLink(folder?.id);
		else if (!isLinked(folder.id) && onLink) onLink(folder?.id);
	};

	const renderImage = (index) => {
		const imageUrl = folder?.documents && folder?.documents[index];
		return (
			<CommonImage
				src={imageUrl || '/images/default_product.svg'}
				alt="product"
				isStatic={imageUrl ? false : true}
			/>
		);
	};

	return (
		<div className="single-collection-item favourtite-single-item">
			<div
				className="product-img-container"
				onClick={() => {
					handleNavigation(folder?.id);
				}}
			>
				<div className="prev-img">{renderImage(0)}</div>
				<div className="prev-img-thumb">
					<div className="single-first">{renderImage(1)}</div>
					<div className="single-second">{renderImage(2)}</div>
				</div>
				<div className="collection-status d-flex justify-content-between align-items-center">
					<span></span>
					{folder?.creationPurposeTagResponse && (
						<span className="status brown-2">{folder?.creationPurposeTagResponse?.text}</span>
					)}
				</div>
				{parentComponent !== 'FAVOURITE_FOLDER_LIST' && (
					<div className="link-btn">
						<button
							onClick={() => handleAction()}
							className={`${
								isLinked && isLinked(folder?.id) && isLinked(folder?.id)
									? 'button outline bg-white size32'
									: 'button size32'
							}`}
						>
							{isLinked && isLinked(folder?.id)
								? 'Unlink from this folder'
								: isCollectionTab
									? 'Link to this folder'
									: ''}
						</button>
					</div>
				)}

				{folder?.numberOfNewProduct > 0 && (
					<div className="new-product-count">
						<span className="status red-3">New {folder?.numberOfNewProduct}</span>
					</div>
				)}
			</div>
			<div className="design-details d-flex justify-content-between pt-1">
				<div className="details">
					<p className="collection-title regular-12 mb-0 gray_dark_01 weight-500">
						{folder?.name} <span>({numberOfProducts || 0})</span>
					</p>
					<ul className="common-list-component mt-1">
						{createdBy && <li className="text-uppercase">{createdBy}</li>}
						{folder?.brandResponse?.name && (
							<li className="text-uppercase">{folder?.brandResponse?.name}</li>
						)}

						{folder?.createdAt && (
							<li className="text-uppercase">
								{isCollectionTab
									? convertTimeToLocal(folder?.createdAt, '', 'DD MMM, YY')
									: convertDateToLocal(folder?.createdAt, 'DD MMM, YY')}
							</li>
						)}
					</ul>
				</div>
			</div>
			{!isMyFavourite(folder?.id) && parentComponent === 'FAVOURITE_FOLDER_LIST' && (
				<div className="option d-flex justify-content-between align-items-center gap-2">
					<div
						className={`pin ${pinnedFolderIds.includes(folder?.id) ? 'pinned' : ''}`}
						onClick={(e) => {
							e.stopPropagation();
							pinnedFolderIds.includes(folder?.id)
								? onUnPinFolder(folder?.id)
								: onPinFolder(folder?.id);
						}}
					>
						<CommonImage
							src={
								pinnedFolderIds.includes(folder?.id)
									? '/icons/Pinned-dark-with-bg.svg'
									: '/icons/Pin-dark-with-bg.svg'
							}
							alt="pin"
							width={36}
							height={36}
							isStatic={true}
						/>
					</div>
					<div className="dropdown">
						<button
							className="btn btn-default dropdown-toggle"
							type="button"
							id={`FOLDER__${folder?.id}`}
							data-toggle="dropdown"
							aria-expanded="false"
						>
							<CommonImage src="/icons/more_icon.svg" alt="more" isStatic={true} />
						</button>

						<ul
							className="dropdown-menu dropdown-menu-right shadow-lg"
							aria-labelledby={`FOLDER__${folder?.id}`}
							role="menu"
							x-placement="bottom-end"
						>
							<li
								className="px-4 pb-3"
								onClick={(e) => {
									e.stopPropagation();
									onDelete(folder);
								}}
							>
								<span className="red">Delete folder</span>
							</li>
						</ul>
					</div>
				</div>
			)}
		</div>
	);
};

export default FavouriteCollectionCard;
